import { render, staticRenderFns } from "./Billing.vue?vue&type=template&id=7bf81819&scoped=true"
import script from "./Billing.vue?vue&type=script&lang=js"
export * from "./Billing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf81819",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bf81819')) {
      api.createRecord('7bf81819', component.options)
    } else {
      api.reload('7bf81819', component.options)
    }
    module.hot.accept("./Billing.vue?vue&type=template&id=7bf81819&scoped=true", function () {
      api.rerender('7bf81819', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/pages/Billing.vue"
export default component.exports